import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Rating, RatingsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class RatingsDataService {

  private uri: string = `${environment.apiUrl}ratings`;
  private cacheKey: string = 'ratings.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getRating(id: number): Observable<Rating|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getRatings(parameters: {[param: string]: string | string[]}): Observable<RatingsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addRating(data: Rating): Observable<Rating|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addRatings(data: Rating[]): Observable<Rating[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateRating(data: Rating): Observable<Rating|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateRatings(data: Rating[]): Observable<Rating[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchRating(data: Rating): Observable<Rating|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchRatings(data: Rating[]): Observable<Rating[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteRating(data: Rating): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteRatings(data: Rating[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((rating) => {
      ids.push(rating.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
